/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Section_PersonalInputs */

const cs_integrations_section_personal = /** @type {(inputs: Integrations_Section_PersonalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osobní a přehled`)
};

const en_integrations_section_personal = /** @type {(inputs: Integrations_Section_PersonalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal & overview`)
};

/**
* | output |
* | --- |
* | "Personal & overview" |
*
* @param {Integrations_Section_PersonalInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integrations_section_personal = /** @type {((inputs?: Integrations_Section_PersonalInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Section_PersonalInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integrations_section_personal(inputs)
	return cs_integrations_section_personal(inputs)
});